// src/i18n/config.ts
import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

// サポートする言語をオブジェクトで定義しています。
// ユーザーが言語を手動で切り替える場合に使用するためのものです。
export const supportedLngs = {
  en: "English",
  ja: "日本語",
};

// 表示言語に合わせて <html lang> を更新する (英語表示なのに "ja" のままだと、読み上げ言語が
// ずれるほか、ブラウザが言語の不一致から翻訳を提案してくることがある)。init より前に登録して初回も拾う
i18n.on("languageChanged", (lng) => {
  if (typeof document === "undefined" || !lng) return;
  document.documentElement.lang = lng.startsWith("en") ? "en" : "ja";
});

i18n
  .use(HttpApi) // 翻訳ファイルを非同期に読み込むため
  .use(initReactI18next) // i18next インスタンスを初期化
  .init({
    fallbackLng: "ja", // フォールバック言語。指定された言語ファイルがない場合などにこの言語が使用される
    returnEmptyString: false, // 空文字での定義を許可に
    supportedLngs: Object.keys(supportedLngs),
    debug: import.meta.env.DEV, // true にすると開発コンソールに i18next が正しく初期化されたことを示す出力が表示される

    // デフォルトは`escapeValue: true`
    // 18next が翻訳メッセージ内のコードをエスケープし、XSS 攻撃から保護するためのもの
    // React がこのエスケープを行ってくれるので、今回はこれをオフにする
    interpolation: {
      escapeValue: false,
    },

    // 翻訳ファイルの読み込み設定
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
  });

export default i18n;
